import { DataTableCol } from "../../../components/tables/types";

export const LmsVideoDataGridCols: DataTableCol[] = [
    {
        title: 'Created Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Title',
        control: 'title',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Course Name',
        control: 'courseName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];